import { createAction } from 'typesafe-actions';
import { saveToLocalStorageHelper } from '../../helpers/saveToLocalStorageHelper';
import { localStorageKey } from '../../helpers/validateLocalStorage';
import type {
  VerifyPolicyAdditionalData,
  VerifyPolicyComplianceProvider,
  VerifyPolicyFlow,
  VerifyPolicyInput,
} from '../reducer/v2/verifyPolicy';

export const _updateComplianceProviderAction = createAction(
  'complianceProvider/update',
)<Partial<VerifyPolicyComplianceProvider>>();

export const updateComplianceProviderAction = (
  input: Partial<VerifyPolicyComplianceProvider>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'complianceProvider',
    localStorageKey: localStorageKey.verifyPolicyComplianceProvider,
    input,
  });
  return _updateComplianceProviderAction(input);
};

export const _resetVerifyPolicyInput = createAction(
  'verifyPolicy/reset_input',
)<void>();

export const resetVerifyPolicyInput = () => {
  localStorage.removeItem(localStorageKey.verifyPolicyInput);
  return _resetVerifyPolicyInput();
};

export const _resetVerifyPolicy = createAction(
  'verifyPolicy/reset_input',
)<void>();

export const resetVerifyPolicy = () => {
  localStorage.removeItem(localStorageKey.verifyPolicyInput);
  localStorage.removeItem(localStorageKey.verifyPolicyFlow);
  localStorage.removeItem(localStorageKey.verifyPolicyComplianceProvider);

  return _resetVerifyPolicy();
};

export const _updateVerifyPolicyFlow = createAction('verifyPolicy/update_flow')<
  Partial<VerifyPolicyFlow>
>();

export const updateVerifyPolicyFlow = (
  input: Partial<VerifyPolicyFlow>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'flow',
    localStorageKey: localStorageKey.verifyPolicyFlow,
    input,
  });
  return _updateVerifyPolicyFlow(input);
};

export const _updateVerifyPolicyInput = createAction(
  'verifyPolicy/update_input',
)<Partial<VerifyPolicyInput>>();

export const updateVerifyPolicyInput = (
  input: Partial<VerifyPolicyInput>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'input',
    localStorageKey: localStorageKey.verifyPolicyInput,
    input,
  });
  return _updateVerifyPolicyInput(input);
};

export const updateVefifyPolicyAdditionalData = (
  input: Partial<VerifyPolicyAdditionalData>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'additionalData',
    localStorageKey: localStorageKey.verifyPolicyAdditionalData,
    input,
  });
  return _updateVerifyPolicyAdditionalData(input);
};

export const _updateVerifyPolicyAdditionalData = createAction(
  'verifyPolicy/update_additional_data',
)<Partial<VerifyPolicyAdditionalData>>();
